import React from 'react';
import styled from 'styled-components';
import { C, Panel, PanelHeader, PanelTitle, PanelSubtitle, PanelBody } from '../chrome';
import Sparkline from './Sparkline';
import ReasonBreakdown from './ReasonBreakdown';

const Section = styled.div`
  & + & { margin-top: 2.4rem; }
`;

const SectionLabel = styled.div`
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${C.textMuted};
  margin-bottom: 1rem;
`;

const SparkRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.4rem;
`;

const SparkValue = styled.div`
  font-size: 2.4rem;
  font-weight: 700;
  color: ${C.textPrimary};
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  span {
    display: block;
    font-size: 1rem;
    font-weight: 600;
    color: ${C.textMuted};
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-top: 0.4rem;
  }
`;

const SparkChart = styled.div`
  flex: 1;
  min-width: 0;
`;

const HourScale = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
  color: ${C.textDim};
  margin-top: 0.6rem;
  font-variant-numeric: tabular-nums;
`;

const TodayPanel = ({ hourlyTrend = [], failureBreakdown = [], connectedToday = 0 }) => {
  return (
    <Panel>
      <PanelHeader>
        <div>
          <PanelTitle>Today</PanelTitle>
          <PanelSubtitle>Throughput trend and failure mix</PanelSubtitle>
        </div>
      </PanelHeader>

      <PanelBody>
        <Section>
          <SectionLabel>Hourly connect trend</SectionLabel>
          <SparkRow>
            <SparkValue>
              {connectedToday}
              <span>connected · 24h</span>
            </SparkValue>
            <SparkChart>
              <Sparkline data={hourlyTrend} color={C.green} height={64} />
              <HourScale>
                <span>00:00</span>
                <span>06:00</span>
                <span>12:00</span>
                <span>18:00</span>
                <span>23:00</span>
              </HourScale>
            </SparkChart>
          </SparkRow>
        </Section>

        <Section>
          <SectionLabel>Why calls didn't connect today</SectionLabel>
          <ReasonBreakdown rows={failureBreakdown} />
        </Section>
      </PanelBody>
    </Panel>
  );
};

export default TodayPanel;
